import { connect } from 'react-redux';

import {
    LogLinkListProps,
    LogLinksListCell
} from '../../components/LogLinksListCell/LogLinksListCell';
import { State } from '../../typings/state';

type StateProps = Pick<LogLinkListProps, 'isGridEnabled'>;

interface DispatchProps {}

type OwnProps = Exclude<LogLinkListProps, 'isGridEnabled'>;

const mapStateToProps = (state: State): StateProps => {
    return {
        isGridEnabled: state.commonData.features.isGridEnabled
    };
};

export const LogLinksListCellContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(mapStateToProps)(LogLinksListCell);
